export default __webpack_public_path__ + "static/media/tShirt1.8765ac1c.jpg";